import React from 'react';

import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import Styles from './ProceduralStepsEMAReview.styles';
import {
  ProceduralStepsDoneDialog,
  ProceduralStepsPdfViewer,
  ProceduralStepsReviewHeader,
  ProceduralStepsReviewPanel
} from './ProceduralStepsEMAReview.views';
import useProceduralStepsEMAReview from './useProceduralStepsEMAReview';

const ProceduralStepsEMAReview = () => {
  const classes = Styles();
  const model = useProceduralStepsEMAReview();
  const { state, selectedStep, actions, hasCurationId } = model;

  return (
    <Box className={classes.root}>
      <Container maxWidth='lg' className={classes.container}>
        {state.mode === 'view' ? (
          <ProceduralStepsReviewHeader
            loading={state.loading}
            hasCurationId={hasCurationId}
            hasSelectedStep={Boolean(selectedStep)}
            total={state.total}
            sessionNewCount={state.sessionNewCount}
            onBack={actions.goBack}
            onEdit={actions.startEdit}
            onAdd={actions.startAdd}
            onDone={actions.requestDone}
          />
        ) : null}

        <Grid container spacing={2}>
          <Grid item xs={12} lg={4}>
            <ProceduralStepsReviewPanel model={model} />
          </Grid>
          <Grid item xs={12} lg={8}>
            <ProceduralStepsPdfViewer pdfUrl={state.pdfUrl} />
          </Grid>
        </Grid>

        <ProceduralStepsDoneDialog model={model} />
      </Container>
    </Box>
  );
};

export default ProceduralStepsEMAReview;
